import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';

@Injectable()
export class UserSessionService {

  private currentUserSession = new BehaviorSubject(false);
  isUserSession = this.currentUserSession.asObservable();

  constructor(
    private route: Router,
    private location: Location
  ) {
    this.route.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  changeUser(currentUserSession: boolean) {
    this.currentUserSession.next(currentUserSession);
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationEnd) {
      let titlee = this.location.prepareExternalUrl(this.location.path());
      if (titlee.charAt(0) === '#') {
        titlee = titlee.slice(2);
      }
      titlee = titlee.split('/').pop();
      if (titlee !== 'login' && titlee !== 'list' && !titlee.includes('licitacoes')) {
        this.isUserSession.subscribe(isUserSession => {
          if (!isUserSession) {
            this.route.navigate(['/login']);
          }
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user-session.service.ts